import feApi from 'api/feApi';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';

const feHelper = {
  callApiGetChargeConnectorDetail: async (id) => {
    const res = await feApi.getChargeConnectorDetail(id);
    return res;
  },

  callApiActivateChargerByQR: async (params) => {
    const res = await feApi.activateChargeByQR(params);
    return res;
  },

  callApiDeactivateCharger: async (params) => {
    try {
      const res = await feApi.deactivateCharge(params);
      return res;
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiCheckPaymentStatus: async (params) => {
    try {
      const res = await feApi.checkPaymentStatus(params);
      const { result, payment } = res;
      if (result === 'success') {
        return payment?.status ?? '';
      }
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  },

  callApiGetBrandList: async (params) => {
    const res = await feApi.getBrandList(params);
    const { result, brands } = res;
    if (result === 'success') {
      return brands;
    }
    return {};
  },

  callApiGetModelList: async (params) => {
    const res = await feApi.getModelList(params);
    const { result, models } = res;
    if (result === 'success') {
      return { models };
    }
    return {};
  },

  callApiGetTransactionDetail: async (params) => {
    const res = await feApi.getTransactionDetail(params);
    const { result, transaction } = res;
    if (result === 'success') {
      return transaction ?? {};
    }
    return {};
  },

  callApiGetTopupCardDetail: async (params) => {
    const res = await feApi.getTopupCard(params);
    return res;
  },

  callApiTopupCard: async (params) => {
    const res = await feApi.topupCard(params);
    return res;
  },

  getCurrentChargePrice: (chargePricing) => {
    if (!chargePricing) return null;

    const now = new Date();
    const timeInHours = now.getHours() + now.getMinutes() / 60;
    const day = now.getDay();

    if (timeInHours >= 22 || timeInHours < 4) {
      return chargePricing.offPeakPrice ?? null;
    }

    if (day === 0 && timeInHours >= 4 && timeInHours < 22) {
      return chargePricing.normalPrice ?? null;
    }

    if (day >= 1 && day <= 6) {
      if (
        (timeInHours >= 9.5 && timeInHours < 11.5) ||
        (timeInHours >= 17 && timeInHours < 20)
      ) {
        return chargePricing.peakPrice ?? null;
      }

      if (
        (timeInHours >= 4 && timeInHours < 9.5) ||
        (timeInHours >= 11.5 && timeInHours < 17) ||
        (timeInHours >= 20 && timeInHours < 22)
      ) {
        return chargePricing.normalPrice ?? null;
      }
    }

    return null;
  },

  // lay ten trang thai giao dich vi
  getWalletTransactionStatusName: (status) => {
    switch (status) {
      case ChargeConstants.WalletTransactionStatus.QUEUED:
        return 'Đang xử lý';
      case ChargeConstants.WalletTransactionStatus.PENDING:
        return 'Chờ thanh toán';
      case ChargeConstants.WalletTransactionStatus.COMPLETED:
        return 'Hoàn thành';
      case ChargeConstants.WalletTransactionStatus.CANCELLED:
        return 'Đã hủy';
      default:
        return '';
    }
  },
  // lay mau sac cua trang thai giao dich vi
  getWalletTransactionStatusColor: (status) => {
    switch (status) {
      case ChargeConstants.WalletTransactionStatus.QUEUED:
        return AppColors.info;
      case ChargeConstants.WalletTransactionStatus.PENDING:
        return AppColors.warning;
      case ChargeConstants.WalletTransactionStatus.COMPLETED:
        return AppColors.primary;
      case ChargeConstants.WalletTransactionStatus.CANCELLED:
        return AppColors.danger;
      default:
        return '';
    }
  },

};

export default feHelper;
